import cx from 'classnames';
import React from 'react';
import styles from '../layout.module.scss';
export const Header = ({ children, hasBottomBorder = false }) => (React.createElement("nav", { className: cx(styles.topNav, {
        [styles.borderBottom]: hasBottomBorder,
    }) }, children));
//# sourceMappingURL=header.js.map